module.exports = __webpack_public_path__ + "img/bookshelf16.b5a9bca8.jpg";